module.exports = __webpack_public_path__ + "static/media/grph-stat-graduate.afb98893.svg";